import React from "react";
import style from './InterveneFeedback.scss'

const InterveneFeedBack = (props) => {
    return (
        <>
            <div className="intervene-feedback">
                <div className="dialogue">
                    <div className="icon">
                        <img src={props.img} alt={props.name} />
                    </div>
                    <div className="dialogue-text">
                        {props.dialogue}
                    </div>
                </div>
                <div className="feedback-text">
                    {props.feedback}
                </div>
            </div>
        </>
    )
}

export default InterveneFeedBack;